import * as helpAndLearningAPI from "app/api/helpAndLearningAPI";
import { CmsHelper } from "app/helpers/cmsHelper";
import PublicModal from "app/screens/PublicScreen/components/PublicModal/PublicModal";
import { useEffect, useState } from "react";
import { FormattedMessage, IntlShape } from "react-intl";
import sanitizeHtml from "sanitize-html";

type Props = {
  intl: IntlShape;
  consentToTermsAndConditions: boolean;
  handleChange: (id: string, value: boolean) => void;
  consentToMarketingValidationError: boolean;
};

const ConsentToTerms = ({
  intl,
  consentToTermsAndConditions,
  handleChange,
  consentToMarketingValidationError,
}: Props) => {
  const [errorConsentToTerms, setErrorConsentToTerms] = useState<string>("");
  const [showModal, setShowModal] = useState(false);
  const [html, setHtml] = useState<any>(null);
  const [screenName, setScreenName] = useState("terms-and-conditions");
  const [languageId, setLanguageId] = useState(
    CmsHelper.getLanguageId(intl.locale)
  );

  const requestContent = () => {
    helpAndLearningAPI
      .requestCMSContent(screenName, languageId)
      .then(resp => {
        setHtml(resp.data.contentlets[0].body);
      })
      .catch(error => {
        console.log(error);
        setHtml("No Content returned");
      });
  };

  const toggleTAC = (ev: React.MouseEvent) => {
    setScreenName("terms-and-conditions");
    setShowModal(true);
  };

  const togglePrivacyPolicy = (ev: React.MouseEvent) => {
    ev.preventDefault();
    setScreenName("privacy-policy");
    setShowModal(true);
  };

  const onCloseModal = () => {
    console.log("closing modal");
    setShowModal(false);
  };

  useEffect(() => {
    requestContent();
  }, []);

  useEffect(() => {
    requestContent();
  }, [showModal]);

  const validateConsentToTerms = (id: string, value: boolean) => {
    setErrorConsentToTerms(
      value
        ? ""
        : intl.formatMessage({
            id: "Required",
          })
    );
  };

  return (
    <div className="form-details__row consent-to-terms">
      <div className="form-details__row--input form-details__row--input--checkbox">
        <span className="checkbox-input">
          <input
            type="checkbox"
            id="consentToTermsAndConditions"
            name="consentToTermsAndConditions"
            checked={consentToTermsAndConditions}
            onBlur={e =>
              validateConsentToTerms(e.target.id, e.currentTarget.checked)
            }
            onChange={() =>
              handleChange(
                "consentToTermsAndConditions",
                !consentToTermsAndConditions
              )
            }
          />
        </span>
        <span className="checkbox-text">
          <FormattedMessage
            tagName=""
            id="home-register-terms-and-conditions-1"
          />
          <span className="active-link" onClick={toggleTAC}>
            <FormattedMessage
              tagName=""
              id="home-register-terms-and-conditions-2"
            />
          </span>
          <FormattedMessage
            tagName=""
            id="home-register-terms-and-conditions-3"
          />{" "}
          <span className="active-link" onClick={togglePrivacyPolicy}>
            <FormattedMessage
              tagName=""
              id="home-register-terms-and-conditions-4"
            />
          </span>
        </span>
      </div>
      <div className="error-message-container__consent-to-terms">
        {errorConsentToTerms && (
          <span className="error-message">{errorConsentToTerms}</span>
        )}
      </div>
      {showModal && (
        <PublicModal
          showModal={showModal}
          closeModal={onCloseModal}
          content={
            <div
              className="footer-container__modal"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(html),
              }}
            />
          }
        />
      )}
    </div>
  );
};

export default ConsentToTerms;
